<!-- 错题卡 -->
<template>
  <div class="warning">
    <div class="header">
      <img @click="pushHome" alt src="@/assets/img/h5/left.png" />
      <div class="tab">
        <div :class="active_type == 1? 'actives': ''" @click="setType(1)" class="tab_li">
          <div>解析模式</div>
          <div class="line" v-if="active_type == 1"></div>
        </div>
        <!-- <div :class="active_type == 0? 'actives': ''" @click="setType(0)" class="tab_li">
          <div>答题模式</div>
          <div class="line" v-if="active_type == 0"></div>
        </div>-->
      </div>
      <img
        @click="collect"
        src="@/assets/img/h5/newQuestioncollect1@2x.png"
        v-if="!data_li.isCollect  && active_type == 1"
      />
      <img
        @click="collect"
        src="@/assets/img/h5/newQuestioncollect2@2x.png"
        v-if="data_li.isCollect  && active_type == 1"
      />
      <img src v-if="  active_type == 0" />
    </div>
    <div class="my_Body" v-if="active_type == 1">
      <div class="question_box">
        <div class="question_header">
          <div class="header_desc" v-if="question_type == 1">单选题</div>
          <div class="header_desc" v-if="question_type == 2">多选题</div>
          <div class="header_desc" v-if="question_type == 3">判断题</div>
          <div class="header_desc" v-if="question_type == 4">简答题</div>
          <div @click="istrue = true" class="header_count">
            {{page_index}}/{{count}}
            <img src="@/assets/img/h5/newQuestiondown@2x.png" />
          </div>
        </div>
        <div class="question_body" v-if="data_li">
          <RadioParsing :bankdata="data_li" :typetext="'单选题'" v-if="question_type == 1"></RadioParsing>
          <CheckParsing :bankdata="data_li" :typetext="'多选题'" v-if="question_type == 2"></CheckParsing>
          <RadioParsing :bankdata="data_li" :typetext="'判断题'" v-if="question_type == 3"></RadioParsing>
          <TextParsing :bankdata="data_li" :typetext="'简答题'" v-if="question_type == 4"></TextParsing>
        </div>
      </div>
    </div>
    <!-- <div class="my_Body" v-if="active_type == 0">
      <div class="question_box">
        <div class="question_header">
          <div class="header_desc" v-if="question_type == 1">单选题</div>
          <div class="header_desc" v-if="question_type == 2">多选题</div>
          <div class="header_desc" v-if="question_type == 3">判断题</div>
          <div class="header_desc" v-if="question_type == 4">简答题</div>
          <div @click="istrue = true" class="header_count">
            <img src="@/assets/img/h5/newQuestiondown@2x.png" />
            <div>{{page_index}}/{{count}}</div>
          </div>
        </div>
        <div class="question_body" v-if="data_li">
          <RadioOption
            :bankdata="data_li"
            :showStatus="true"
            :typetext="'单选题'"
            v-if="question_type == 1"
            v-on:getchildval="getchildval"
          ></RadioOption>
          <CheckOption
            :bankdata="data_li"
            :showStatus="true"
            :typetext="'多选题'"
            v-if="question_type == 2"
            v-on:getchildval="getchildval"
          ></CheckOption>
          <RadioOption
            :bankdata="data_li"
            :typetext="'判断题'"
            v-if="question_type == 3"
            v-on:getchildval="getchildval"
          ></RadioOption>
          <TextOption
            :bankdata="data_li"
            :typetext="'简答题'"
            v-if="question_type == 4"
            v-on:getchildval="getchildval"
          ></TextOption>
        </div>
      </div>
    </div>-->
    <div class="footer">
      <div class="page">
        <el-pagination
          :current-page.sync="page_index"
          :disabled="loading"
          :page-size="1"
          :total="count"
          @current-change="handleSizeChange"
          layout="prev,next"
          next-text="下一题"
          prev-text="上一题"
        ></el-pagination>
        <div
          @click="pushHome"
          class="submit"
          v-if="dataAll.length == page_index && active_type == 1"
        >结束</div>
        <div
          @click="submit_sub"
          class="submit"
          v-if="dataAll.length == page_index && active_type == 0"
        >提交</div>
      </div>
    </div>
    <ParsingSheet
      :activeindex="page_index"
      :bankdata="dataAll"
      :isanwers="true"
      :istrues="istrue"
      :status="status"
      v-if="dataAll && dataAll.length > 0 && active_type == 1"
      v-on:getstatus="getstatus"
      v-on:getvalue="getvalue"
    ></ParsingSheet>
    <WarningAndCollectSheet
      :activeindex="page_index"
      :bankdata="copyData"
      :istrues="istrue"
      :numcount="numCount"
      v-if="copyData  && copyData.length > 0  && active_type == 0"
      v-on:getcopyvalue="getcopyvalue"
      v-on:getstatus="getstatus"
    ></WarningAndCollectSheet>
  </div>
</template>

<script>
import ParsingSheet from '@/components/h5/questionBank/ParsingSheet.vue'
import CheckParsing from '@/components/h5/questionBank/CheckParsing.vue'
import RadioParsing from '@/components/h5/questionBank/RadioParsing.vue'
import TextParsing from '@/components/h5/questionBank/TextParsing.vue'
// import CheckOption from '@/components/h5/questionBank/CheckOption.vue'
// import RadioOption from '@/components/h5/questionBank/RadioOption.vue'
// import TextOption from '@/components/h5/questionBank/TextOption.vue'
import WarningAndCollectSheet from '@/components/h5/questionBank/WarningAndCollectSheet.vue'
import * as QUESTION_API from '@/api/ExaminationAPI'
import * as examination_API from '@/api/ExaminationAPI'
export default {
  components: {
    // CheckOption,
    // RadioOption,
    // TextOption,
    ParsingSheet,
    CheckParsing,
    RadioParsing,
    TextParsing,
    WarningAndCollectSheet
  },
  data () {
    return {
      ExaminationInfo: {},
      examinationItemList: [],
      courseData: {},
      actionType: 0,  //6错题 7收藏
      examinationId: '',
      initData: '',
      baseUrl: sessionStorage.getItem('base_url') || '',
      loading: false,
      count: 0,
      page_index: 1,
      question_type: 1,
      token: '',
      data_li: '',
      dataAll: [],
      copyData: [],
      istrue: false,
      is_keep: false,
      active_type: 1,
      isFeed: false,
      isDisbeld: true,
      lastExaminationItemId: '',
      status: true,
      sessionData: [],
      numCount: 0,
      is_mode: false,
      isBlack: false,
      go_status: false,
      coutnWrong: 0,
      coutnWronges: 0
    };
  },
  computed: {
  },
  watch: {},
  created () {
    //从课程详细页面错题跳转此页面
    if (this.$route.params.Obj) {
      this.ExaminationInfo = this.$route.params.examination
      this.actionType = this.$route.params.actionType
    } else {
      this.ExaminationInfo = JSON.parse(sessionStorage.getItem('warningAndCollectPage')).examination
      this.actionType = JSON.parse(sessionStorage.getItem('warningAndCollectPage')).actionType
    }
    this.examinationId = this.ExaminationInfo.examinationId
    if (this.actionType === 6) {
      this.initWarning() //错题初始化
    }
    if (this.actionType === 7) {
      this.initcollect() //收藏初始化
    }
  },
  mounted () {
  },
  destroyed () {
    sessionStorage.removeItem('h5WarningAndCollect')
    sessionStorage.removeItem('warningAndCollecCopy')
  }, //生命周期 - 销毁完成
  //方法集合
  methods: {
    submit_sub () {
      this.$router.push('CollectionFinished')
    },
    submitExaminationTestLog (data) {
      examination_API.submitExaminationTestLog(data).then(res => {
        if (res && Number(res.code) === 0) {
          let customerExaminationTestLogId = res.data
          this.ExaminationInfo.customerExaminationTestLogId = customerExaminationTestLogId;
          this.$message.success(res.msg)
          this.$router.push({
            name: 'ResultPage',
            params: this.ExaminationInfo
          })
          sessionStorage.setItem('resultPage', JSON.stringify(this.ExaminationInfo))
          this.push_status = true
        } else {
          this.$message.warning(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    initcollect () {
      const loading = this.$loading({
        text: '数据加载中……'
      });
      let params = {
        examinationId: this.examinationId,
        topTypeId: this.ExaminationInfo.topTypeId,
        courseId: this.ExaminationInfo.courseId
      }
      //查询当前用户答题记录数据
      QUESTION_API.getExaminationItemCollect(params).then(res => {
        loading.close();
        console.log('查询当前用户收藏')
        console.log('88', res)
        if (res && Number(res.code) === 0) {
          this.examinationItemList = res.data;
          this.count = res.data.length
          let data = []
          let copy = []
          for (let i = 0; i < this.examinationItemList.length; i++) {
            data[i] = this.examinationItemList[i].examinationItemEntity
            data[i].order = (i + 1)
            copy[i] = this.examinationItemList[i].examinationItemEntity
            copy[i].order = (i + 1)
          }
          this.dataAll = data
          sessionStorage.setItem('h5WarningAndCollect', JSON.stringify(this.dataAll))
          this.copyData = copy
          console.log('datall', this.dataAll)
          this.count = this.dataAll.length
          this.data_li = this.dataAll[this.page_index - 1]
          this.question_type = this.data_li.questionType
          if (sessionStorage.getItem('warningAndCollecCopy')) {
            // 保证刷新后用户的数据不丢失
            this.numCount = 0
            this.copyData = JSON.parse(sessionStorage.getItem('warningAndCollecCopy'))
            for (let i = 0; i < this.copyData.length; i++) {
              if (this.copyData[i].select instanceof Array) {
                if (this.copyData[i].select.length > 0) {
                  this.numCount++
                }
              } else {
                if (this.copyData[i].select) {
                  this.numCount++
                }
              }
            }
          }
        } else {
          this.$message.warning(res.msg)
        }


      }).catch(err => {
        loading.close();
        console.log(err)
      })
    },


    initWarning () {
      let params = {
        examinationId: this.examinationId,
        type: 3,
        withTestLog: true,//查询用户答题数据需要字段
        wrongOnly: true, //只查看错题题目
        withCollect: true,
        courseId: this.ExaminationInfo.courseId
      }
      QUESTION_API.examinationItemWrong(params).then(res => {
        console.log('查询当前用户错题', res)
        if (res && Number(res.code) === 0) {
          this.examinationItemList = res.data;
          this.count = res.data.length
          let data = []
          let copy = []
          for (let i = 0; i < this.examinationItemList.length; i++) {
            data[i] = this.examinationItemList[i]
            data[i].order = (i + 1)
            copy[i] = this.examinationItemList[i]
            copy[i].order = (i + 1)

          }
          this.dataAll = data
          sessionStorage.setItem('h5WarningAndCollect', JSON.stringify(this.dataAll))
          this.copyData = copy
          console.log('datall', this.dataAll)
          this.count = this.dataAll.length
          this.data_li = this.dataAll[this.page_index - 1]
          this.question_type = this.data_li.questionType
          if (sessionStorage.getItem('warningAndCollecCopy')) {
            // 保证刷新后用户的数据不丢失
            this.numCount = 0
            this.copyData = JSON.parse(sessionStorage.getItem('warningAndCollecCopy'))
            for (let i = 0; i < this.copyData.length; i++) {
              if (this.copyData[i].select instanceof Array) {
                if (this.copyData[i].select.length > 0) {
                  this.numCount++
                }
              } else {
                if (this.copyData[i].select) {
                  this.numCount++
                }
              }
            }
            console.log(99999999999)
          }
        } else {
          this.$message.warning(res.msg)
        }

      }).catch(err => {
        console.log(err)
      })
    },
    setType: function (val) {
      console.log(val, '888')
      this.active_type = val
      this.loading = true
      if (this.active_type == 0) {
        if (sessionStorage.getItem('warningAndCollecCopy')) {
          // 保证刷新后用户的数据不丢失
          console.log('保证刷新后用户的数据不丢失')
          this.copyData = JSON.parse(sessionStorage.getItem('warningAndCollecCopy'))
        } else {
          for (let i = 0; i < this.copyData.length; i++) {
            this.copyData[i].select = ''
          }
        }
        this.status = false
        this.page_index = 1
        this.data_li = this.copyData[this.page_index - 1]
        this.question_type = this.data_li.questionType
        this.count = this.copyData.length
        sessionStorage.setItem('setType', 0)
      } else {
        this.dataAll = JSON.parse(sessionStorage.getItem('h5WarningAndCollect'))
        this.status = false
        this.page_index = 1
        this.data_li = this.dataAll[this.page_index - 1]
        this.question_type = this.data_li.questionType
        this.count = this.dataAll.length
        sessionStorage.setItem('setType', 1)
      }

      let that = this
      setTimeout(function () {
        that.loading = false
      }, 1000)
    },
    handleSizeChange: function (val) {
      console.log('var', val)
      if (this.active_type == 0) {
        this.page_index = val
        this.data_li = this.copyData[this.page_index - 1]
        this.question_type = this.data_li.questionType
        return;
      }
      this.data_li = this.dataAll[this.page_index - 1]
      this.question_type = this.data_li.questionType
    },

    pushHome: function () {
      this.$router.back()
    },

    // 关闭弹窗
    getstatus: function (val) {
      this.istrue = val
    },


    //试题收藏
    collect () {
      if (this.data_li.isCollect) {
        this.editCollect(1)
      } else {
        this.editCollect(0)
      }
    },
    //试题收藏
    editCollect (isDelete) {
      const loading = this.$loading({
        text: '数据加载中……'
      });
      let myAnswer = this.data_li.select.indexOf('[') > -1 ? '' : this.data_li.select
      let data = {
        examinationItemId: this.data_li.examinationItemId,
        examinationId: this.data_li.examinationId,
        questionType: this.data_li.questionType,
        myAnswer: myAnswer,
        topTypeId: this.ExaminationInfo.topTypeId,
        courseId: this.ExaminationInfo.courseId,
        isDelete: isDelete
      }
      QUESTION_API.editExaminationItemCollect(data).then(res => {
        loading.close();
        if (res && Number(res.code) === 0) {
          this.$message.success(res.msg, 200)
          this.data_li.isCollect = !this.data_li.isCollect
        } else {
          this.$message.warning(res.msg)
        }
      }).catch(err => {
        loading.close();
        console.log(err)
      })
    },


    // 点击事件判断调用收藏接口
    collects: function () {
      if (this.data_li.collect) {
        this.delCollect()
      } else {
        this.setCollect()
      }
    },
    // 点击获取答案
    getchildval: function (obj) {
      console.log('点击获取答案888', obj)
      if (obj.examinationItemId) {
        for (let i = 0; i < this.copyData.length; i++) {
          if (this.copyData[i].examinationItemId === obj.examinationItemId) {
            if (obj.select instanceof Array) {
              //如果是多选题
              if (obj.select.length > 0) {
                this.copyData[i].select = obj.select.sort().toString().replace(/[,]/g, '###')
              } else {
                this.copyData[i].select = ''
              }
            } else {
              console.log(i)
              this.copyData[i].select = obj.select
              console.log('obj', this.copyData)
            }
          }
        }
        sessionStorage.setItem('warningAndCollecCopy', JSON.stringify(this.copyData))
        let num = 0
        for (let s = 0; s < this.copyData.length; s++) {
          if (this.copyData[s].select) {
            num++
          }
        }
        this.numCount = num
      }
    },
    // 点击跳转题目
    getvalue: function (val) {
      this.page_index = val.order
      console.log('213234', val)
      if (this.active_type == 0) {
        this.data_li = this.copyData[this.page_index - 1]
        this.question_type = this.data_li.questionType
        return;
      }
      this.data_li = this.dataAll[this.page_index - 1]
      this.question_type = this.data_li.questionType
    },


    getcopyvalue (val) {
      console.log('copy  val', val)
      this.page_index = val.order
      this.data_li = this.copyData[this.page_index - 1]
      this.question_type = this.data_li.questionType
    },

  },
}
</script>
<style scoped>
.header {
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: bold;
  padding: 0.84375rem;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
}
.tab {
  display: flex;
  align-items: center;
}
.tab_li {
  margin: 0 0.5rem;
  font-weight: 0;
  position: relative;
}
.actives {
  color: #3aacffff;
}
.line {
  width: 100%;
  height: 2px;
  background-color: #3aacffff;
  position: absolute;
  left: 0;
  bottom: -0.90625rem;
}
.header img {
  width: 1.2rem;
}
.footer {
  position: fixed;
  height: 3rem;
  display: flex;
  padding: 0 0 0 4%;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  left: 0;
  bottom: 0;
  box-shadow: 0px -2px 8.5px 0px rgba(237, 237, 237, 1);
  background: #fff;
}
.Feed {
  position: relative;
}

.Feedback {
  position: absolute;
  left: 0.35rem;
  width: 6.25rem;
  display: flex;
  justify-content: center;
  padding-top: 0.35rem;
  color: #fff;
  height: 2.125rem;
  top: -2.7rem;
  background-size: cover;
}

.page {
  position: relative;
}

.timeOut {
  display: inline-flex;
  color: #3aacffff;
  align-items: center;
}

.timeOut img {
  height: 1.125rem;
  margin-right: 0.25rem;
}

.submit {
  position: absolute;
  font-size: 1rem;
  letter-spacing: 0.5rem;
  color: #3aacffff;
  background-color: #fff;
  padding: 0.25rem 0.5625rem;
  cursor: pointer;
  right: 0;
  top: 0.2rem;
}

.footer button {
  color: #3aacffff;
}

.footer button span {
  font-size: 1rem;
}

.footer button:disabled {
  color: #bbb;
}
.my_Body {
  width: 100%;
  height: 85vh;
  overflow-y: scroll;
  padding: 0.84375rem;
}

.question_box {
  width: 100%;
}

.question_header {
  margin-top: 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.question_body {
  margin-top: 1rem;
}

.question_header img {
  width: 0.65rem;
  margin-left: 0.2rem;
}

.header_count {
  display: inline-flex;
  align-items: center;
}

/*隐藏滚动条*/
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}
.warning {
  background: #fff;
}
/* .footer {
  position: fixed;
  height: 3rem;
  padding: 0 0 0 4%;
  width: 100%;
  align-items: center;
  left: 0;
  bottom: 0;
  box-shadow: 0px -2px 8.5px 0px rgba(237, 237, 237, 1);
  display: flex;
  justify-content: flex-end;
  background: #fff;
} */
</style>